// Mirrors backend calc_emi; server value is the source of truth.
export const calcEmi = (principal, rate, months, method) => {
  const P = Number(principal), R = Number(rate), n = parseInt(months, 10);
  if (!(P > 0) || !(n >= 1) || !(R >= 0)) return null;
  let emi, interest;
  if (method === "flat") {
    interest = (P * R * n) / 1200;
    emi = (P + interest) / n;
  } else {
    const r = R / 1200;
    emi = r === 0 ? P / n : (P * r * (1 + r) ** n) / ((1 + r) ** n - 1);
    interest = emi * n - P;
  }
  return { emi: Math.round(emi * 100) / 100, totalInterest: Math.round(interest * 100) / 100, totalPayable: Math.round((P + interest) * 100) / 100 };
};

export const addMonthsISO = (iso, months) => {
  if (!iso) return "";
  const d = new Date(iso);
  d.setMonth(d.getMonth() + months);
  return d.toISOString().slice(0, 10);
};
